import { uri } from '../constants';

export const createPayout = async (payoutData) => {
  try {
    const response = await fetch(`${uri}/payout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payoutData)
    });
    if (!response.ok) {
      throw new Error('Failed to create payout');
    }
    return await response.json();
  } catch (error) {
    console.error('Error in createPayout:', error);
    throw error;
  }
};

export const getPayouts = async () => {
  try {
    const response = await fetch(`${uri}/payout`);
    if (!response.ok) throw new Error('Failed to fetch payouts');
    return await response.json();
  } catch (error) {
    console.error('Error fetching payouts:', error);
    throw error;
  }
};

export const updatePayouts = async ({payout_id, status}) => {
  try {
    const response = await fetch(`${uri}/payout/${payout_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status })
    });
    if (!response.ok) throw new Error('Failed to update payout');
    return await response.json();
  } catch (error) {
    console.error('Error updating payout:', error);
    throw error;
  }
}

export const requestPayout = async (payoutData) => {
  try {
    const response = await fetch('/api/payouts/request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payoutData)
    });

    if (!response.ok) {
      throw new Error('Failed to request payout');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message || 'Error requesting payout');
  }
};
